import useForm from "../../../hooks/useForm";
import AuthHeader from "../sections/Auth.header";
import AuthRight from "../sections/Auth.Right";
import AuthFooter from "../sections/Auth.Footer";
import AuthIllustration from "../components/AuthIllustration";
import AuthLayout from "../../../layouts/Auth.layout";
import { useLoginApi } from "../apis";
import { AlertStatus } from "@chakra-ui/react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAlert } from "../../../hooks/useAlert";
import { useCallback, useEffect } from "react";
import { useAppSelector } from "../../../store";

const LoginPage = () => {
  const { loginWithEmailAndPassword } = useLoginApi();
  const { message, loading } = useAppSelector((s) => s.auth);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { render: AlertRender, showAlert, hideAlert } = useAlert();

  const urlMessage = searchParams.get("message");
  const urlStatus = searchParams.get("status");

  const { render: formRender, setLoading } = useForm<"email" | "password">({
    initialValues: {
      email: {
        type: "email",
        value: "",
        label: "Email Address",
      },
      password: {
        type: "password",
        value: "",
        label: "Password",
        showEye: true,
      },
    },
    inputSize: "lg",
    showLabel: true,
    submitLabel: "Login",
    onSubmit: (data) => {
      loginWithEmailAndPassword(data);
    },
  });

  // Effect to update loading state
  useEffect(() => {
    setLoading(loading);
  }, [loading, setLoading]);

  useEffect(() => {
    if (urlMessage)
      showAlert({
        status: (urlStatus as AlertStatus) || "info",
        message: urlMessage,
      });
    else if (message)
      showAlert({ status: message.status, message: message.value });
    else hideAlert();
  }, [message, urlMessage]);

  return (
    <AuthLayout
      Header={AuthHeader({
        onBack: useCallback(() => {
          navigate("/welcome");
        }, []),
      })}
      Left={AuthIllustration()}
      Right={AuthRight({
        form: formRender({}),
        error: AlertRender,
      })}
      Footer={AuthFooter({ for: "login" })}
    />
  );
};

export default LoginPage;
